export const config = {
    appname: 'AIA',
    client_id: '656670435136467', // App ID
    facebook_app_id: '656670435136467', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    api: 'apiaaw2',
    api_prefix: 'stg16',
    agency_id: '120634',
    bzbsUrl: 'https://apigateway.buzzebees-uat.com/api/aia',
    bzbsModuleUrl: 'https://aiamodule.buzzebees-uat.com',
    bzbsWallet: 'https://stgwallet.buzzebees.com',
    bzbsAddItemFromList: 'https://stg.buzzebees.com/api/cart/',
    // bzbsBlobUrl: 'https://stgstoragebuzzebees.blob.core.windows.net',
    bzbsBlobUrl: 'https://cdn.buzzebees-uat.com/th',
    bzbsShoppingCartUrl: 'https://shoppingcartservice15.buzzebees-uat.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule15.buzzebees-uat.com',
    bzbAddItem: 'https://stgc.buzzebees.com/payment/AddItem.aspx?id=',
    bzbsShoppingBasket: 'https://stgc.buzzebees.com/paymentV2/cart.aspx',
    bzbsWebUrl: 'https://stw.buzzebees.com',
    bzbsPointExpire: 'https://stw.buzzebees.com/Views/Point/Expire.aspx?token=',
    miscUrl: 'https://stgmisc.buzzebees.com',
    bzbsGaId: '',
    liffId: '',
    subscription_key: 'fd4e3ff660bc4a5f8ada52cd3bca1301',
    api_version: '16',
    country_prefix: 'th',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    birthdate_category_id: '9445207',
    aiaPhoneUrl: 'https://iserviceuat2.aia.co.th/th/my-aia/privilege-bzb.html?method=telephone&value=',
    aiaEmailUrl: 'https://iserviceuat2.aia.co.th/th/my-aia/privilege-bzb.html?method=email&value=',
    aiaWebsiteUrl: 'https://iserviceuat2.aia.co.th/th/my-aia/privilege-bzb.html?method=openurlinbrowser&value=',

    aiaPlusPhoneUrl: 'thsuperapp://privilege/privilege?method=telephone&value=',
    aiaPlusEmailUrl: 'thsuperapp://privilege/privilege?method=email&value=',
    aiaPlusWebsiteUrl: 'thsuperapp://privilege/privilege?method=openurlinbrowser&value=',

    firebase: {
        apiKey: "AIzaSyDgcqmTxKmuiW98Ue7jaZCp5XPRSYQIblo",
        authDomain: "aia-staging.firebaseapp.com",
        projectId: "aia-staging",
        storageBucket: "aia-staging.appspot.com",
        messagingSenderId: "781021800565",
        appId: "1:781021800565:web:61aa52ca83be28e30e303c",
        measurementId: "G-4TKZHB8T4Y"
    }
};
